import Vue from 'vue'
import Vuex from 'vuex'
import getters from './getters'
import app from './modules/app'
import settings from './modules/settings'
import user from './modules/user'
import tagsView from './modules/tagsViews'
import device from './modules/device'
import topHeader from './modules/header'
import conference from './modules/conference'


Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    app,
    settings,
    user,
    tagsView,
    topHeader,// 大屏顶部信息功能栏
    device,
    conference,// 左边
  },
  getters,

  state: {

  },
  mutations: {},
  actions: {},
})

export default store
